"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M7.518 4.505a1.638 1.638 0 0 0-.505 1.177c0 .442.182.865.505 1.178l5.371 5.145-5.371 5.1c-.33.317-.517.748-.518 1.197 0 .45.184.88.513 1.2.33.318.777.497 1.243.498.467 0 .915-.177 1.245-.494l6.498-6.295a1.59 1.59 0 0 0 .5-1.205 1.606 1.606 0 0 0-.12-.657c-.087-.21-.216-.4-.38-.558l-6.497-6.286a1.738 1.738 0 0 0-.568-.374 1.79 1.79 0 0 0-1.348 0 1.737 1.737 0 0 0-.568.374Z"
  })]
});